import { z } from 'zod';

import { ChangeEmailFormFields } from '../types';

export const changeEmailFormValidationSchema = z.object({
  [ChangeEmailFormFields.email]: z.email('Should be valid email'),
  [ChangeEmailFormFields.newEmail]: z.email('Should be valid email'),
});
